import { render, staticRenderFns } from "./professor-notas-pendentes.vue?vue&type=template&id=995b5e6c&scoped=true&"
import script from "./professor-notas-pendentes.vue?vue&type=script&lang=js&"
export * from "./professor-notas-pendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995b5e6c",
  null
  
)

export default component.exports